import React from "react";
import { Typography, withStyles } from "@material-ui/core";
import connect from "react-redux/es/connect/connect";
import { withRouter } from 'react-router-dom';
import DropDownSearchList from 'common/components/DropDownSearchList';
import Grid from '@material-ui/core/Grid'
import {
  fetchTeachers, fetchLocationSearch, fetchAttendanceReviewFilterCourses, fetchReviewPeriods,
  updateScheduleTeacherSearch, updateScheduleBuildingSearch, updateScheduleLocationSearch, updateScheduleCourseSearch, matchUserAsTeacher,
  resetReviewPeriodsPickerPage, attendanceReviewLoadPage
} from 'redux/admin/Actions'
import styles from './styles';
import FancySelect from "common/components/FancySelect";

function teacherToSelectOption(teacher) {
  return teacher.fullName;
}

function locationToSelectOption(location) {
  return location.name;
}

function courseToSelectOption(course) {
  return (
    <Grid container>
      <Grid item xs={3}>
        {course.courseCode}
      </Grid>
      <Grid item xs={9}>
        {course.courseDescription}
      </Grid>
    </Grid>
  )
}

function courseShowSelected(course) {
  let result = course.courseCode + ` (${course.courseDescription})`;
  return result.trim();
}

class SchedulePicker extends React.Component {
  getSearchParams = () => {
    const search = (this.props.location && this.props.location.search) || window.location.search;
    const params = new URLSearchParams(search);
    const searchParams = {};
    for (const [k, v] of params.entries()) {
      searchParams[k] = v;
    }
    return searchParams;
  }

  componentDidMount() {
    if (!this._pageMounted) {
      const searchParams = this.getSearchParams();
      this.props.attendanceReviewLoadPage({ searchParams });
      this._pageMounted = true
    }
  }

  componentWillUnmount() {
    if (this._pageMounted) {
      this.props.resetReviewPeriodsPickerPage();
      this._pageMounted = false
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedFacilityId !== prevProps.selectedFacilityId) {
      this.props.fetchTeachers();
      this.props.fetchAttendanceReviewFilterCourses();
    }

    if (this.props.selectedTeacher !== prevProps.selectedTeacher) {
      const newTeacherSearch = this.props.selectedTeacher ? teacherToSelectOption(this.props.selectedTeacher) : '';
      if (newTeacherSearch !== this.props.teacherSearch) {
        this.props.updateScheduleTeacherSearch(newTeacherSearch);
      }
    }

    if (this.props.selectedLocation !== prevProps.selectedLocation) {
      const newLocationSearch = this.props.selectedLocation ? locationToSelectOption(this.props.selectedLocation) : '';
      if (newLocationSearch !== this.props.locationSearch) {
        this.props.updateScheduleLocationSearch(newLocationSearch);
      }
    }

    if (this.props.selectedCourse !== prevProps.selectedCourse) {
      const newCourseSearch = this.props.selectedCourse ? courseShowSelected(this.props.selectedCourse) : '';
      if (newCourseSearch !== this.props.courseSearch) {
        this.props.updateScheduleCourseSearch(newCourseSearch);
      }
    }
  }

  setQueryParams = (params) => {
    const location = this.props.location || window.location;
    const qs = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key]) {
        qs.set(key, params[key]);
      }
    })
    const search = qs.toString() ? `?${qs.toString()}` : '';
    this.props.history.push({ pathname: location.pathname, search });
  }

  handleTeacherInputChange = (inputValue) => {
    this.props.updateScheduleTeacherSearch(inputValue);
    this.props.fetchTeachers(inputValue);
  };

  handleTeacherSelect = (teacher) => {
    this.setQueryParams({ teacher: teacher.id });
  };

  handleBuildingInputChange = (inputValue) => {
    this.props.updateScheduleBuildingSearch(inputValue);
  };

  handleBuildingSelect = (buildingId) => {
    this.setQueryParams({ building: buildingId });
  };

  handleLocationInputChange = (inputValue) => {
    this.props.updateScheduleLocationSearch(inputValue);
    this.props.fetchLocationSearch(inputValue);
  };

  handleLocationSelect = (location) => {
    const searchParams = this.getSearchParams();
    let newParams = {}
    if (searchParams.building) {
      newParams.building = searchParams.building
    }
    newParams.location = location.id

    this.setQueryParams(newParams);
  };

  handleCourseInputChange = (inputValue) => {
    this.props.updateScheduleCourseSearch(inputValue);
    this.props.fetchAttendanceReviewFilterCourses(inputValue);
  };

  handleCourseSelect = (course) => {
    this.setQueryParams({ course: course.id });
  };

  render() {
    const {
      classes,
      locations = [],
      teachers = [],
      courses = [],
      buildings = [],
    } = this.props;

    const { teacherSearch, locationSearch, courseSearch, selectedBuildingId } = this.props;
    
    return (
      <React.Fragment>
        <Typography align="left" color="textSecondary">
          Select a teacher, course or location to review attendance periods.
        </Typography>
        <div className={classes.selectorRow}>
          <div style={{width: '500px'}}>
            <DropDownSearchList
              searchString={teacherSearch}
              onInputChange={this.handleTeacherInputChange}
              onSelectChange={this.handleTeacherSelect}
              placeholder="Search teachers..."
              items={teachers}
              itemToSelectOption={teacherToSelectOption}
              itemKey={t => t.id}
              statusMessage="Select a teacher"
              fillInputOnSelect={true}
            />
          </div>
          <span className={classes.orText}>|</span>
          <div style={{width: '500px'}}>
            <DropDownSearchList
              searchString={courseSearch}
              onInputChange={this.handleCourseInputChange}
              onSelectChange={this.handleCourseSelect}
              placeholder="Search courses..."
              items={courses}
              itemToSelectOption={courseToSelectOption}
              itemToShowSelected={courseShowSelected}
              itemKey={l => l.id}
              statusMessage="Select a course"
              fillInputOnSelect={true}
            />
          </div>
        </div>

        <div className={classes.selectorRow}>
          <div style={{ width: '500px' }}>
            <FancySelect
              dispatchUpdate={(prop) => {
                this.handleBuildingSelect(prop.val)
              }}
              label='Building'
              propertyName={'buildingId'}
              currentItem={buildings.find(b => b.id === selectedBuildingId)}
              items={buildings}
            />
          </div>
          <span className={classes.orTextInVisible}>|</span>
          <div style={{width: '500px', marginTop: '12px'}}>
            <DropDownSearchList
              searchString={locationSearch}
              onInputChange={this.handleLocationInputChange}
              onSelectChange={this.handleLocationSelect}
              placeholder="Search locations..."
              items={locations}
              itemToSelectOption={locationToSelectOption}
              itemKey={l => l.id}
              statusMessage="Select a location"
              fillInputOnSelect={true}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  ...state.admin.attendanceReview,
  buildings: state.admin.allBuildings || []
});

const mapDispatchToProps = {
  updateScheduleTeacherSearch,
  updateScheduleBuildingSearch,
  updateScheduleLocationSearch,
  updateScheduleCourseSearch,
  fetchTeachers,
  fetchLocationSearch,
  fetchAttendanceReviewFilterCourses,
  fetchReviewPeriods,
  matchUserAsTeacher,
  resetReviewPeriodsPickerPage,
  attendanceReviewLoadPage
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(SchedulePicker)));